// extracted by mini-css-extract-plugin
export default {"main":"BaseLayout_main__QN4VS","content":"BaseLayout_content__XM8Qo"};